import {chunk} from '@benchling/js-utils';
import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import Col from 'ui-library/bs/Col';
import FormGroup from 'ui-library/bs/FormGroup';
import Row from 'ui-library/bs/Row';
import FieldLabel from 'ui-library/inputs/FieldLabel';
import Modal from 'ui-library/modals/Modal';

export interface MetadataGridCell {
  component: React.ReactNode;
  label: string;
}

export interface ViewMetadataModalProps {
  title: string;
  gridCells: Array<MetadataGridCell>;
  additionalContent?: JSX.Element;
  onRequestClose: () => void;
  onRequestSubmit: () => void;
}

export function MetadataGridContents({
  gridCells,
  additionalContent,
}: {
  gridCells: Array<MetadataGridCell>;
  additionalContent?: JSX.Element | null;
}): JSX.Element {
  return (
    <>
      {[...chunk(gridCells, 2)].map((rowCells, rowIndex) => (
        <Row key={rowIndex}>
          {rowCells.map(({label, component}, colIndex) => (
            <Col
              sm={6}
              key={`${label}-${rowIndex}-${colIndex}`}
              dataTestAttrs={{
                component: 'ViewMetadataModal',
                element: 'column',
                key: label,
              }}
            >
              <FormGroup>
                <FieldLabel label={label} />
                <div
                  {...getTestProps({
                    component: 'ViewMetadataModal',
                    element: 'value',
                    key: label,
                  })}
                >
                  {component}
                </div>
              </FormGroup>
            </Col>
          ))}
        </Row>
      ))}
      {additionalContent != null && (
        <div
          {...getTestProps({
            component: 'ViewMetadataModal',
            element: 'div',
            key: 'additionalContent',
          })}
        >
          {additionalContent}
        </div>
      )}
    </>
  );
}

export default function ViewMetadataModal({
  title,
  gridCells,
  additionalContent,
  onRequestClose,
}: ViewMetadataModalProps): JSX.Element {
  return (
    <Modal
      mediumLarge={true}
      title={title}
      onRequestClose={onRequestClose}
      dataTestAttrs={{component: 'ViewMetadataModal', element: 'root'}}
    >
      <MetadataGridContents gridCells={gridCells} additionalContent={additionalContent} />
    </Modal>
  );
}
